// extracted by mini-css-extract-plugin
module.exports =  {"fullCategoryPath":"fullCategoryPath__TB5Sf"};